'use client';

import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
import { aspCond } from '@module/helpers/conditions/condition';
import useModalStore from '@module/stores/useModalStore';
function LoginRegisterMenuItem() {
  const $ = _c(5);
  const pushModal = useModalStore(_temp);
  let t0;
  if ($[0] !== pushModal) {
    t0 = () => {
      if (aspCond.if("new-asp")) {
        SettingConfig.aspUtils?.goLogin();
        return;
      }
      pushModal({
        type: "AUTH_MODAL",
        id: "LoginRegisterMenuItem"
      });
    };
    $[0] = pushModal;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClick = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="pl-2.5 text-[13px]">서비스 이용을 위해<br />로그인이 필요합니다.</div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== handleClick) {
    t2 = <div className="flex justify-between">{t1}<button type="button" className="h-[32px] w-[83px] rounded-md border border-borderBg18 bg-colorBg15 px-4 text-[15px]" onClick={handleClick}>로그인</button></div>;
    $[3] = handleClick;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(state) {
  return state.pushModal;
}
export default LoginRegisterMenuItem;